(() => {
  'use strict';
  const purchasable = state => ['in_stock', 'preorder', 'available'].includes(state);

  function publishSelection(container, variantId, state) {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy?.analyticsProcessingAllowed?.() || !window.Shopify?.analytics?.publish) return;
    try {
      window.Shopify.analytics.publish('tcs:variant_selected', {
        product_id: container.id.replace(/^prod-/, ''),
        variant_id: String(variantId || ''),
        purchase_state: state,
        device_layout: window.matchMedia('(max-width: 799px)').matches ? 'mobile' : 'desktop'
      });
    } catch (_) {}
  }

  function productTools(container) {
    const select = container.querySelector('.product-form__variants');
    const mainButton = container.querySelector('[name="add"]');
    if (!select || !mainButton) return;
    const cards = container.querySelector('.tcs-holo-options');
    if (cards) {
      cards.hidden = false;
      container.querySelectorAll('.selector-wrapper').forEach(item => { item.hidden = true; });
      cards.addEventListener('change', event => {
        if (!event.target.matches('input[type="radio"]')) return;
        const native = container.querySelector('.single-option-selector');
        native.value = event.target.value;
        native.dispatchEvent(new Event('change', {bubbles: true}));
      });
    }
    const bar = container.querySelector('[data-sticky-purchase]');
    const stickyButton = bar?.querySelector('[data-sticky-add]');
    let above = false;
    const update = variantId => {
      const option = Array.from(select.options).find(option => option.value === String(variantId));
      const state = option?.dataset.purchaseState?.trim() || 'unavailable';
      cards?.querySelectorAll('input').forEach(input => { input.checked = input.dataset.variantId === String(variantId); });
      if (!bar) return;
      bar.querySelector('[data-sticky-price]').textContent = option?.dataset.price || '';
      const title = option?.dataset.title;
      bar.querySelector('[data-sticky-option]').textContent = title && title !== 'Default Title' ? title + (cards ? ' ' + cards.dataset.holos : '') : '';
      bar.querySelector('[data-sticky-status]').textContent = window.Sunrise.strings.tcs_purchase[state];
      stickyButton.textContent = mainButton.textContent.trim();
      stickyButton.disabled = !purchasable(state);
      stickyButton.classList.toggle('tcs-preorder-button', state === 'preorder');
    };
    update(select.value);
    container.addEventListener('tcs:purchase-state', event => {
      update(event.detail.variantId);
      publishSelection(container, event.detail.variantId, event.detail.state);
    });
    if (bar) {
      stickyButton.addEventListener('click', () => { if (!mainButton.disabled) mainButton.click(); });
      const visibility = () => {
        const blockingDialog = Array.from(document.querySelectorAll('[aria-modal="true"]:not([hidden])')).some(dialog => {
          const style = getComputedStyle(dialog);
          return style.visibility !== 'hidden' && style.display !== 'none' && dialog.getBoundingClientRect().height > 0;
        });
        const banner = document.querySelector('#shopify-pc__banner');
        const cookieVisible = banner && banner.getBoundingClientRect().height > 0;
        bar.hidden = !above || Boolean(blockingDialog) || Boolean(cookieVisible);
      };
      if ('IntersectionObserver' in window) new IntersectionObserver(entries => {
        above = entries[0].boundingClientRect.bottom < 0;
        visibility();
      }).observe(mainButton);
      document.addEventListener('scroll', visibility, {passive: true});
    }
  }

  function collectionTools(panel) {
    const results = document.querySelector('[data-collector-results]');
    const grid = results?.querySelector('ul.collection-th');
    if (!grid) return;
    const original = Array.from(grid.children);
    const pagination = results.querySelector('[data-collector-pagination]');
    const status = panel.querySelector('[data-filter-status]');
    const controls = Array.from(panel.querySelectorAll('[data-facet]'));
    let cards = [], loading;
    function apply() {
      const selected = Object.fromEntries(controls.map(control => [control.dataset.facet, control.value]));
      if (!Object.values(selected).some(Boolean)) {
        grid.replaceChildren(...original);
        if (pagination) pagination.hidden = false;
        status.textContent = '';
        return;
      }
      const matches = [];
      const availability = selected.availability || (panel.dataset.preferStock ? 'in_stock' : '');
      for (const source of cards) {
        if (['game','era','condition','edition'].some(key => selected[key] && source.dataset[key] !== selected[key])) continue;
        const variants = JSON.parse(source.querySelector('[data-filter-variants]').textContent);
        const choices = variants.filter(variant => (!availability || variant.state === availability) && (!selected.price || variant.price <= Number(selected.price)) && (!selected.price || purchasable(variant.state)));
        if (!choices.length) continue;
        const card = source.cloneNode(true);
        card.querySelector('[data-filter-variants]').remove();
        if (selected.availability || selected.price) {
          const variant = choices.sort((a,b) => a.price-b.price)[0];
          card.querySelector('a.prod-th').href = variant.url;
          card.querySelector('[data-card-price]').textContent = variant.money;
          const badge = document.createElement('span');
          badge.className = 'tcs-badge tcs-badge--' + variant.state;
          badge.textContent = variant.label + (variant.title === 'Default Title' ? '' : ' · ' + variant.title);
          card.querySelector('[data-card-availability]').replaceChildren(badge);
        }
        matches.push(card);
      }
      grid.replaceChildren(...matches);
      if (pagination) pagination.hidden = true;
      status.textContent = matches.length + ' ' + panel.dataset.results;
    }
    async function load() {
      if (loading) return loading;
      status.textContent = panel.dataset.loading;
      loading = (async () => {
        cards = [];
        let url = new URL(panel.dataset.url, location.origin);
        url.searchParams.set('view', 'tcs-filter-data');
        const sort = new URL(location.href).searchParams.get('sort_by');
        if (sort) url.searchParams.set('sort_by', sort);
        const seen = new Set();
        while (url) {
          if (url.origin !== location.origin || seen.has(url.href)) throw new Error('Invalid pagination');
          seen.add(url.href);
          const response = await fetch(url.href, {credentials: 'same-origin'});
          if (!response.ok) throw new Error('Collection unavailable');
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const wrapper = page.querySelector('[data-filter-page]');
          if (!wrapper) throw new Error('Collection data missing');
          cards.push(...wrapper.querySelectorAll('[data-filter-card]'));
          url = wrapper.dataset.next ? new URL(wrapper.dataset.next, location.origin) : null;
          if (url) url.searchParams.set('view', 'tcs-filter-data');
        }
        for (const control of controls) {
          const key = control.dataset.facet;
          if (!['price','availability'].includes(key)) {
            const values = [...new Set(cards.map(card => card.dataset[key]).filter(Boolean))].sort();
            control.replaceChildren(control.options[0]);
            values.forEach(value => {
              const option = document.createElement('option');
              option.value = value;
              option.textContent = value;
              control.add(option);
            });
          }
          control.disabled = false;
        }
        status.textContent = '';
      })().catch(() => { status.textContent = panel.dataset.error; loading = null; });
      return loading;
    }
    panel.addEventListener('toggle', () => { if (panel.open) load(); });
    panel.addEventListener('change', apply);
    panel.querySelector('[data-filter-clear]').addEventListener('click', () => {
      controls.forEach(control => { control.value = ''; });
      apply();
      if (!loading) load();
    });
  }
  function init() {
    document.querySelectorAll('[data-section-type="product"]').forEach(productTools);
    document.querySelectorAll('[data-collector-filters]').forEach(collectionTools);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
